import { Tabs } from "antd";
import React, { useState } from "react";
import RegisteredPatientContainer from "./RegisteredPatientContainer";
import AddPatientContainer from "./AddPatientContainer";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const { Title, Text } = Typography;

const RegistrationContainerTabs = () => {

  const [activeTab, setActiveTab] = useState<any>("newRegistration");
    const {auth} = useSelector((state: RootState) => state);
  const [componentKeys, setComponentKeys] = useState<any>({
    newRegistration: 0,
    registeredPatient: 0,
  });

  const onChange = (key: any) => {
    setActiveTab(key);

    setComponentKeys((prev: any) => ({
      ...prev,
      [key]: prev[key] + 1,
    }));
  };

  const items = [
    {
      key: "newRegistration",
      label: "New Registration",
      children: (
        <AddPatientContainer
          key={`new-registration-${componentKeys.newRegistration}`}
        />
      ),
    },
    {
      key: "registeredPatient",
      label: "Registered Patient",
      children: (
        <RegisteredPatientContainer
          key={`registered-patient-${componentKeys.registeredPatient}`}
        />
      ),
    },
  ];

  return (
    <div  style={{ padding: "4px 10px", background: "#F1F8FF", minHeight: "90vh" }}>
      <div style={{ marginBottom: 10 }}>
        <Title level={4}>Hello, {auth?.userName || "User"} ! 👋</Title>
        <Text type="secondary">Good to see you back again</Text>
      </div>

      <Tabs
        activeKey={activeTab}
        items={items}
        onChange={onChange}
        type="card"
        size="small"
        className="registration-tabs"
      />
    </div>
  );
};

export default RegistrationContainerTabs;